import GraphContent from "../graph_content";
import { RequestParamsMaker } from "./make_request_params";
import axios from "axios";

export function reloadKeys(self: GraphContent) {
  return new Promise<void>(async (resolve, reject) => {
    try {
      const reqParams = RequestParamsMaker.makeAutoUpdateKeysParams(self);
      const response = await axios(reqParams);
      self.partitions = response.data.res.partitions;
      self.attributes = response.data.res.attributes;
      return resolve();
    } catch (e) {
      return reject(e);
    }
  });
}

export function initReloadKeys(self: GraphContent) {
  return new Promise<void>(async (resolve, reject) => {
    try {
      const reqParams = RequestParamsMaker.makeGetSensorKeysParams(self);
      const response = await axios(reqParams);
      console.log(response);
      self.partitions = response.data.res.partitions;
      self.attributes = response.data.res.attributes;
      return resolve();
    } catch (e) {
      return reject(e);
    }
  });
}
